import '../lib/readingtime.js';

$(() => {
    const mHeigths = ['.js-mh-article-content, .js-mh-feature-content']
    $.each(mHeigths, function(i, selector) {
        $(selector).matchHeight({
            property: 'height'
        })
    })
    $('.js-reading-target').each(function() {
        let _this = $(this)
        _this.readingTime({
            remotePath: _this.data('link'),
            readingTimeTarget: _this.find('.time-to-read > .ttr-target'),
            remoteTarget: '.js-typography',
            lessThanAMinuteString: '1 min',
            wordsPerMinute: 200
        })
    })
    $('.js-page-readtime').readingTime({
        readingTimeTarget: $('.time-to-read > .ttr-target'),
        lessThanAMinuteString: '1 min',
        wordsPerMinute: 200
    })
})